import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { CFDI } from '../../../../interfaces/Sales/Catalogs/CFDIs';
import GenericPromises from '../../../../api/GenericPromises';
import { Menuitem } from '../../../../interfaces/Security/menu';
import { Spinner } from '../../../../components/Commons/Spinner/Spinner';
import { Header } from '../../../../components/Header';
import { Button } from '@mui/material';
import { UpdateCFDIs } from './update';
import { usePermissions } from '../../../../hooks/usePermissions';
import { GenericDialog } from '../../../../components/Dialogs/Dialog';
import { ButtonStyled } from '../../../../theme/buttons';
import useSnackBar from '../../../../components/Commons/SnackBar/useSnackBar';

export const ViewCFDIs = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const navigate = useNavigate();
  const [cfdiLocal, setCfdiLocal] = useState<CFDI>();
  const [openDialog, setOpenDialog] = useState(false);
  const [dataloaded, setDataLoaded] = useState(false);
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const { GenericGetResource, GenericDeleteResource } = GenericPromises();

  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const { GetResourceByUrl } = usePermissions();

  const onDelete = () => {
    GenericDeleteResource(`/cfdi/${cfdiLocal?.cfdi_id}`)
      .then(() => {
        setOpenDialog(false);
        navigate("/cfdi", { state: { method: "delete" }, replace: true });
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
        setOpenDialog(false);
      })
  }


  useEffect(() => {
    if (location.state === null) return navigate("/cfdi", { state: {}, replace: true });
    GenericGetResource(`/cfdi/${location.state.row.cfdi_id}`)
      .then(
        (response) => {
          setCfdiLocal(response.data);

          GetResourceByUrl(`/cfdi`)
            .then((response1) => {
              setResourceScreen((prev) => response1);
              setDataLoaded(true);
            })
            .catch((error) => {
              showSnackBar(error.message, "error");
            });
        }
      ).catch((error) => {
        showSnackBar(error.message, "error");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!dataloaded && <Spinner />}
      {dataloaded &&
        <>
          <Header
            title={t("cfdis.title-view")}
            child={
              <div className='d-flex flex-row-reverse m-1'>
                {resourceScreen?.delete === true &&
                  <ButtonStyled variant="contained" className="my-1" onClick={() => setOpenDialog(true)}>{t("generic.buttons.delete")}</ButtonStyled>
                }
                <Button variant="outlined" onClick={() => { navigate("/cfdi", { replace: true }) }}>{t("generic.buttons.goback")}</Button>
              </div>
            }
          />
          {resourceScreen?.read &&
            <>
              <div>
                <UpdateCFDIs cfdiLocal={cfdiLocal} isEdit={resourceScreen?.update} />
              </div>
            </>
          }
        </>
      }
      <GenericDialog
        title={t("generic.dialog.delete")}
        content={t("cfdis.dialog.delete")}
        open={openDialog}
        setOpen={setOpenDialog}
        onAcept={onDelete}
      />
      <SnackbarComponent />
    </>
  )
}
